// For Firebase JS SDK v7.20.0 and later, measurementId is optional
import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyBMBjZ_7amSXxPnCTrHlrQr1E-QHjL2Qzk",
  authDomain: "social-media-eb84b.firebaseapp.com",
  projectId: "social-media-eb84b",
  storageBucket: "social-media-eb84b.appspot.com",
  messagingSenderId: "168498736722",
  appId: "1:168498736722:web:bdbc7d0f8b4d6cfc1f398b"
};

const firebaseApp = firebase.initializeApp(firebaseConfig);
const db = firebaseApp.firestore();
const auth = firebase.auth();
const provider = new firebase.auth.GoogleAuthProvider();

export { auth, provider };
export default db;
